import { render } from "./TasksList.vue?vue&type=template&id=25c9682b"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=25c9682b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__